// extracted by mini-css-extract-plugin
export default {"lubemathPageWrapper":"LubematchPage_lubemathPageWrapper__liPKF","ol":"LubematchPage_ol__s+-Ys"};